import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NSGridModule } from '@norfolk-southern/accessns-components';

import { EBillCarDisputeColumnHeaderComponent } from '@ruby/modules/ebill/submodules/ebill-car-dispute/components/cells/ebill-car-dispute-column-header.component';
import { EBillCarDisputeComponent } from '@ruby/modules/ebill/submodules/ebill-car-dispute/components/ebill-car-dispute.component';
import { EBillCarDisputeActionsContainer } from '@ruby/modules/ebill/submodules/ebill-car-dispute/containers/cells/ebill-car-dispute-actions.container';
import { EBillCarDisputeContainer } from '@ruby/modules/ebill/submodules/ebill-car-dispute/containers/ebill-car-dispute.container';
import { EBillCarDisputeRoutingModule } from '@ruby/modules/ebill/submodules/ebill-car-dispute/ebill-car-dispute-routing.module';
import { DirectivesModule } from '@ruby/shared/directives/directives.module';

@NgModule({
  declarations: [EBillCarDisputeContainer, EBillCarDisputeComponent, EBillCarDisputeActionsContainer, EBillCarDisputeColumnHeaderComponent],
  imports: [
    CommonModule,
    EBillCarDisputeRoutingModule,
    MatSelectModule,
    NSGridModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatInputModule,
    FormsModule,
    MatDatepickerModule,
    DirectivesModule
  ],
  exports: [
    EBillCarDisputeContainer
  ]
})
export class EBillCarDisputeModule {}
